import { isValidAddress, toChecksumAddress } from '@ethereumjs/util';
import { toBase58Address } from '@particle-network/auth';
import { ParticleChains, chains } from '@particle-network/chains';
import { iframeWallet } from '@particle-network/iframe-wallet';
import BigNumber from 'bignumber.js';
import dayjs from 'dayjs';
import { Interface } from 'ethers';
import numbro from 'numbro';
import { particleChain, particleChainV2 } from '../config';
import { SUPPORTED_TOKEN_TYPE, TokenIcon } from '../types';
import erc20Abi from './../abi/erc-20-abi';
export * from './didUtils';
export * from './number-utils';
export const gasFee = (params) => {
    const { gasPrice, maxFeePerGas, maxPriorityFeePerGas, baseFee, gasLimit } = params;
    if (maxFeePerGas && maxPriorityFeePerGas) {
        //eip 1559
        const fee = numbro(maxPriorityFeePerGas)
            .add(baseFee)
            .multiply(10 ** 9)
            .multiply(gasLimit)
            .divide(10 ** 18)
            .format({
            trimMantissa: true,
            mantissa: 10,
        });
        const maxFee = numbro(maxFeePerGas)
            .add(baseFee)
            .multiply(10 ** 9)
            .multiply(gasLimit)
            .divide(10 ** 18)
            .format({
            trimMantissa: true,
            mantissa: 10,
        });
        return {
            fee,
            maxFee,
        };
    }
    else if (gasPrice) {
        const maxFee = numbro(gasPrice)
            .multiply(10 ** 9)
            .multiply(gasLimit)
            .divide(10 ** 18)
            .format({
            trimMantissa: true,
            mantissa: 10,
        });
        return {
            maxFee,
        };
    }
    return {
        maxFee: '',
    };
};
export const getParticleChainInfo = (chainName, chainId) => {
    let result = {};
    result = {
        ...(Object.entries(ParticleChains).find((item) => item[1].name.toLowerCase() == chainName.toLowerCase() && item[1].id == chainId)?.[1] || {}),
    };
    if (result?.name?.toLowerCase?.() == 'tron') {
        result.evmUnit = 'mwei';
    }
    else {
        result.evmUnit = 'ether';
    }
    result.decimals = result?.nativeCurrency?.decimals || 18;
    result.symbol = result?.nativeCurrency?.symbol || 'ETH';
    return result;
};
/**
 * 代币规则：
 * 最多保留小数点后9位，只展示到最后一个非零数字位。当整数位超过5位，小数后位数逐渐减少。整数为超过15位时，使用科学计数法，小数点后两位
 * @param bn
 * @param decimalLength
 * @param type 0:正常显示 1：如果等于0返回 <0.00001
 * @param maxLength 最大长度
 */
export const tokenAmountFormat = (bn, decimalLength = 9, type = 0, maxLength = 18) => {
    let res;
    const str = bn.toFixed();
    let [int, dec] = str.split('.');
    if (int.length > 15) {
        res = bn.toExponential(9);
    }
    else {
        if (int.length > 5) {
            decimalLength = 9 - (int.length - 5);
        }
        if (dec && decimalLength > 0) {
            const decArr = dec.split('');
            dec = decArr.slice(0, decimalLength).join('');
            res = new BigNumber(`${int}.${dec}`).toFixed();
        }
        else {
            res = int;
        }
    }
    if (type === 1 && Number(res) === 0) {
        res = '<0.00001';
    }
    if (res.length > maxLength) {
        const [intPart, decPart] = res.split('.');
        if (intPart.length > maxLength) {
            res = intPart.slice(0, maxLength);
        }
        else if (decPart) {
            const remainingLength = maxLength - intPart.length - 1;
            res = `${intPart}.${decPart.slice(0, remainingLength)}`;
        }
    }
    return res;
};
/**
 * 法币规则：
 * 展示小数点后4位，只展示到最后一个非零数字位。整数位全部展示
 */
export const fiatAmountFormat = (bn, decimalLength = 4) => {
    const str = bn.toFixed();
    let [int, dec] = str.split('.');
    if (dec) {
        const decArr = dec.split('');
        dec = decArr.slice(0, decimalLength).join('');
        return new BigNumber(`${int}.${dec}`).toFixed();
    }
    else {
        return int;
    }
};
export const formatPng = (src = '') => {
    if (!src || src.includes('x-oss-process'))
        return src;
    return src + (src.includes('?') ? '&' : '?') + 'x-oss-process=image/format,png';
};
export const isServer = () => typeof window === 'undefined';
export const isMobile = () => {
    if (isServer())
        return false;
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
};
/**
 * Switch chain
 * @param particleProvider
 * @param chainName
 * @param chainId
 * @returns
 */
export const switchChain = async (particleProvider, chainName, chainId) => {
    if (!particleProvider) {
        return;
    }
    let providerChainId = particleProvider?.getChainId
        ? await particleProvider.getChainId()
        : particleProvider?.request
            ? await particleProvider.request({ method: 'eth_chainId' })
            : particleProvider?.auth?.getChainId?.();
    if (!!providerChainId && providerChainId.toString().startsWith('0x')) {
        providerChainId = parseInt(providerChainId, 16);
    }
    const targetChainId = chainId || Number(process.env.NEXT_PUBLIC_CHAIN_ID);
    const targetChainName = chainName || process.env.NEXT_PUBLIC_CHAIN_NAME;
    if (providerChainId != targetChainId) {
        console.log('providerChainId', providerChainId, 'targetChainId', targetChainId, 'isSwitchChainResult', !!window?.switchChainResult);
        if (!window.switchChainResult) {
            window.switchChainResult = new Promise(async (resolve, reject) => {
                if (!particleProvider.isParticleNetwork && isMobile()) {
                    await new Promise((resolve, reject) => {
                        try {
                            window.__webWalletData.events.emit('event:switchChain:approve');
                            window.__webWalletData.events.once('event:switchChain:execute', () => {
                                resolve(true);
                            });
                        }
                        catch (error) {
                            reject(error);
                        }
                    });
                }
                const params = {
                    id: Number(targetChainId),
                    name: targetChainName,
                };
                console.log('connectKit.switchChain', params);
                const switchChain = particleProvider?.switchChain
                    ? window.__webWalletData.walletSwitchChain(particleProvider, targetChainId)
                    : window.__webWalletData.inAuthCoreIframe
                        ? window.__webWalletData.walletSwitchChain(iframeWallet.ethereum, targetChainId)
                        : window.__connectKit.switchChain({
                            id: Number(targetChainId),
                            name: targetChainName,
                        });
                switchChain
                    .then(() => {
                    setTimeout(() => {
                        window.switchChainResult = null;
                        console.log('switchChainSuccess');
                    }, 1000);
                    window.__webWalletData.events.emit('event:switchChain:success');
                    resolve(true);
                })
                    .catch((error) => {
                    setTimeout(() => {
                        window.switchChainResult = null;
                        console.log('switchChainFail');
                    }, 1000);
                    reject(error);
                });
            });
        }
        return window.switchChainResult;
    }
    return;
};
export const subString = (str = '', start = 5, end = 5) => {
    // if (str.length > len) {
    return str.substring(0, start) + '...' + str.substring(str.length - end, str.length);
    // } else {
    //   return str;
    // }
};
export const formWalletAddress = (chainName, address) => {
    if (!address || !chainName) {
        return '';
    }
    if (chainName.toLowerCase() == 'tron') {
        address = toBase58Address(address);
    }
    else if (chainName.toLowerCase() !== 'solana') {
        address = toChecksumAddress(address);
    }
    return address;
};
/**
 * 验证比特币地址 {34,63} 长度, 不能包含 . 不能是evm地址
 * @param address
 * @returns
 */
export function validBitcoinAddress(address = '') {
    var regex = /^[a-zA-HJ-NP-Z0-9]{34,63}$/;
    return !isValidAddress(address) && !address.includes('.') && regex.test(address);
}
export const sleep = (time = 300) => {
    return new Promise((resolve) => setTimeout(resolve, time));
};
export const getTokenListCacheKey = (address, chainName, chainId) => {
    if (!address || !chainName || !chainId) {
        console.log('address, chainName, chainId is required');
        return '';
    }
    return `tokenList_${chainName.toLowerCase()}_${chainId}_${address}`.toLowerCase();
};
export const getCacheTokenList = (address, chainName, chainId) => {
    chainName = (chainName || window.__webWalletData.chainName).toLowerCase();
    chainId = Number(chainId || window.__webWalletData.chainId);
    address = (address || window.__webWalletData.address);
    const key = getTokenListCacheKey(address, chainName, chainId);
    return JSON.parse(window.localStorage.getItem(key) || '[]');
};
export const setCacheTokenList = (list, address, chainName, chainId) => {
    chainName = (chainName || window.__webWalletData.chainName).toLowerCase();
    chainId = Number(chainId || window.__webWalletData.chainId);
    address = (address || window.__webWalletData.address);
    const key = getTokenListCacheKey(address, chainName, chainId);
    window.localStorage.setItem(key, JSON.stringify(list));
};
export const waitForTransactionReceipt = async (provider, tx) => {
    let receipt = null;
    do {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        receipt = await provider.request({
            method: 'eth_getTransactionReceipt',
            params: [tx],
        });
    } while (!receipt);
    return receipt;
};
/**
 * 记录调用栈并存入 localStorage，key: callStack，用数组存储。
 * 超过 50 条记录时删除最早的一条。
 *
 * @param {string} [chainId=''] - 链 ID，默认值为空字符串
 * @param {string} [chainName=''] - 链名称，默认值为空字符串
 * @param {string} [address=''] - 地址，默认值为空字符串
 * @param {any} [sourceError] - 源错误对象，默认值为 undefined
 *
 */
export function logStack(chainId = '', chainName = '', address = '', sourceError) {
    try {
        const key = 'callStack';
        const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
        const error = new Error();
        const stack = error.stack;
        const callStack = JSON.parse(localStorage.getItem(key) || '[]') || [];
        const newRecord = {
            time,
            stack,
            sourceStack: sourceError?.stack,
            errorMessge: sourceError?.message,
            chainId,
            chainName,
            address,
        };
        callStack.push(newRecord);
        if (callStack.length > 50) {
            callStack.shift();
        }
        localStorage.setItem(key, JSON.stringify(callStack));
        console.log('Recorded call stack:', newRecord);
    }
    catch (error) {
        // 捕获并处理任何可能的错误
        console.log('logStack error', error);
    }
}
export const getTokenIcon = (symbol) => {
    return TokenIcon[symbol] || '';
};
export const shortAddress = (address) => {
    if (!address) {
        return '';
    }
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
};
export const getNewEVMChainInfoById = (chainId) => {
    if (particleChain.id === chainId) {
        return particleChain;
    }
    else if (particleChainV2.id === chainId) {
        return particleChainV2;
    }
    else {
        return chains.getEVMChainInfoById(chainId);
    }
};
export const getUniversalTokenDecimals = (type) => {
    return type === SUPPORTED_TOKEN_TYPE.USDC || type === SUPPORTED_TOKEN_TYPE.USDT ? 6 : 18;
};
export function parseToAddress(data) {
    const iface = new Interface(erc20Abi);
    const res = iface.decodeFunctionData('transfer', data);
    return res?.[0] || '';
}
//# sourceMappingURL=index.js.map